"use strict";
module.exports = require("styled-jsx/style");

//# sourceMappingURL=styled-jsx.js.map